import { Component, ViewEncapsulation, OnInit, inject, input, output } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';

import { FocusDirective } from '../../components/focus/focus.directive';
import { HelpService } from './help.service';

@Component({
  selector: 'td-wb-help-mobile-article',
  templateUrl: 'help-mobile-article.component.html',
  styleUrls: ['help-mobile-article.component.scss'],
  imports: [
    TranslateDirective,
    FocusDirective
  ],
  encapsulation: ViewEncapsulation.None
})
export class HelpMobileArticleComponent implements OnInit {
  private readonly helpService = inject(HelpService);

  readonly articleId = input<string>(undefined);
  readonly articleContent = input<string>(undefined);
  readonly hasFocus = input<boolean>(undefined);

  readonly indexId = output<string>();

  ngOnInit(): void {
    if (this.hasFocus()) {
      this.helpService.scrollToArticle(this.articleId());
    }
  }

  backToIndex(): false {
    this.indexId.emit(this.articleId());
    return false;
  }
}
